import { Checkbox, Empty, Form, Skeleton, Space, Tag, Typography } from 'antd';
import { useQuery } from 'react-query';

import imgFiBox from '../../../../assets/img/lockerBlue.png';
import { listCabinetsQuery } from '../../../../store/api/listCabinets';
import './style.less';

const { Text } = Typography;

/** Хоосон/ачаалж байгаа үеийн ижил харагдац */
const StateBox = ({ children }) => (
  <div style={{ padding: '16px 0' }}>{children}</div>
);

const PPBoxSelection = ({ committeeId, selectedBox, setSelectedBox }) => {
  const { data, isLoading, isError } = useQuery(
    ['CabinetLocker', committeeId],
    () => listCabinetsQuery(committeeId),
    { enabled: Boolean(committeeId) }
  );

  const lockers = data?.data?.result ?? [];

  const renderBody = () => {
    if (!committeeId) {
      return (
        <StateBox>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              <Text type="secondary" style={{ fontSize: 13 }}>
                Эхлээд хороо/багаа сонгоно уу.
              </Text>
            }
            style={{ margin: 0 }}
          />
        </StateBox>
      );
    }

    if (isLoading) {
      return (
        <StateBox>
          <Skeleton active paragraph={{ rows: 2 }} title={false} />
        </StateBox>
      );
    }

    if (isError || !lockers.length) {
      return (
        <StateBox>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              <Text type="secondary" style={{ fontSize: 13 }}>
                {isError
                  ? 'PP Box-ын жагсаалтыг татаж чадсангүй. Дахин оролдоно уу.'
                  : 'Сонгосон хороонд PP Box байхгүй байна.'}
              </Text>
            }
            style={{ margin: 0 }}
          />
        </StateBox>
      );
    }

    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
        {lockers.map((locker) => (
          <PPBoxItem
            key={locker._id ?? locker.code}
            item={locker}
            /**
             * `_id`/`code`-ээр тулгана. Өмнө нь объектын хаягаар (`===`)
             * тулгадаг тул refresh хийсний дараа (sessionStorage-оос сэргэсэн
             * шинэ объект) сонголт нь тодрохоо больдог байсан.
             */
            selected={isSameBox(locker, selectedBox)}
            disabled={isFull(locker)}
            onSelect={() => setSelectedBox(locker)}
          />
        ))}
      </div>
    );
  };

  return (
    <Form.Item label="Сонгох боломжтой локерууд" style={{ marginBottom: 0 }}>
      {renderBody()}
    </Form.Item>
  );
};

export default PPBoxSelection;

const PPBoxItem = ({ item, selected = false, onSelect, disabled = false }) => (
  <div
    onClick={disabled ? undefined : onSelect}
    className={`item-container${selected ? ' selected' : ''}${disabled ? ' disabled' : ''}`}
  >
    <div className="box-info">
      <img src={imgFiBox} alt="" height={32} width={16} />
      <div>
        <div className="box-code">{item.code}</div>
        <div className="box-location">{item.addressName}</div>
      </div>
    </div>

    <Space size={6}>
      {disabled && <Tag color="error">Дүүрэн</Tag>}
      {/* Дарах үйлдлийг бүрхүүл div нь хийнэ — хоёр удаа дуудагдахгүй */}
      <Checkbox
        className="checkbox"
        checked={selected}
        disabled={disabled}
        onChange={() => undefined}
        style={{ pointerEvents: 'none' }}
      />
    </Space>
  </div>
);

/** Хоёр PP Box ижил эсэх — объектын хаяг биш кодоор нь тулгана */
const isSameBox = (a, b) => {
  if (!a || !b) return false;
  if (a._id && b._id) return a._id === b._id;
  return Boolean(a.code) && a.code === b.code;
};

/** Ямар нэг хэмжээний бүх хайрцаг дүүрэн бол сонгох боломжгүй */
const isFull = (item) =>
  (item?.boxAvailabilityStatus ?? []).some((status) => status?.avaiable === 0);
